// styles/theme.js
export const defaultTheme = {
    backColor: '#F1F1F1',
    headerColor: '#5ABDE7',
    asideColor: 'linear-gradient(0deg, #00587A, #00587A), #A7A7A7',
    buttonBackColor: '#5ABDE7',
    primaryColor: '#000',
    secondaryColor: '#FFF'

}

export const darkTheme = {
    backColor: '#2A2A2A',
    headerColor: '#454545',
    asideColor: 'linear-gradient(0deg, #8E8E8E, #8E8E8E), #A7A7A7',
    buttonBackColor: '#5ABDE7',
    primaryColor: '#FFF',
    secondaryColor: '#000'
}


export const greenThemme = {
    backColor: '#F1F1F1',
    headerColor: '#61EC5E',
    asideColor: 'linear-gradient(0deg, #0C460B, #0C460B), #A7A7A7',
    buttonBackColor: '#61EC5E',
    primaryColor: '#000',
    secondaryColor: '#FFF'
}

export const redTheme = {
    backColor: '#F1F1F1',
    headerColor: '#FF4C4C',
    asideColor: 'linear-gradient(0deg, #4F0000, #4F0000), #A7A7A7',
    buttonBackColor: '#FF4C4C',
    primaryColor: '#000',
    secondaryColor: '#FFF'
}

export const yellowTheme = {
    backColor: '#F1F1F1',
    headerColor: '#F3D846',
    asideColor: 'linear-gradient(0deg, #635407, #635407), #A7A7A7',
    buttonBackColor: '#F3D846',
    primaryColor: '#000',
    secondaryColor: '#FFF'
}

export const grayTheme = {
    backColor: '#F1F1F1',
    headerColor: '#959595',
    asideColor: 'linear-gradient(0deg, #3A3A3A, #3A3A3A), #A7A7A7',
    buttonBackColor: '#959595',
    primaryColor: '#000',
    secondaryColor: '#FFF'
}

export const pinkTheme = {
    backColor: '#F1F1F1',
    headerColor: '#F562D5',
    asideColor: 'linear-gradient(0deg, #5C0048, #5C0048), #A7A7A7',
    buttonBackColor: '#F562D5',
    primaryColor: '#000',
    secondaryColor: '#FFF'
}

